
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 120 125","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.285 39.73c0-1.801 1.46-3.261 3.261-3.261h34.905a3.261 3.261 0 010 6.521H42.546c-1.8 0-3.26-1.46-3.26-3.26zm3.261 16.382h34.905a3.261 3.261 0 000-6.522H42.546a3.261 3.261 0 000 6.522zm27.145 9.874a3.262 3.262 0 00-3.26-3.261H42.547a3.261 3.261 0 000 6.522h23.895a3.26 3.26 0 003.261-3.261h-.013zM57.886.768L44.843 11.83a3.26 3.26 0 00-.384 4.598 3.263 3.263 0 004.597.385L60 7.551l10.982 9.274a3.262 3.262 0 104.213-4.982L62.15.782A3.261 3.261 0 0057.9.795l-.013-.027zm60.953 47.935A3.261 3.261 0 01120 51.194V112.8a11.52 11.52 0 01-11.505 11.505h-96.99A11.52 11.52 0 010 112.799V51.194c0-.96.426-1.872 1.161-2.49l12.287-10.305a3.261 3.261 0 014.598.385 3.261 3.261 0 01-.385 4.598l-9.13 7.67 14.113 9.978V29.725a8.363 8.363 0 018.361-8.36h58.03a8.364 8.364 0 018.36 8.36V61.03l14.126-9.991-9.051-7.644a3.26 3.26 0 01-.385-4.597 3.263 3.263 0 014.598-.385l12.156 10.29zM29.125 65.66L60 87.495 90.872 65.66V29.779a1.84 1.84 0 00-1.838-1.84h-58.07a1.84 1.84 0 00-1.839 1.84V65.66zm84.352-8.008L76.629 83.739l26.413 20.164a3.262 3.262 0 01-3.913 5.218L71.046 87.665l-9.13 6.521h-.001c-1.13.8-2.64.8-3.77 0l-9.13-6.521-28.07 21.456a3.263 3.263 0 01-4.565-.652 3.263 3.263 0 01.652-4.566L43.37 83.712 6.52 57.651v55.148a4.995 4.995 0 004.983 4.983h96.99a4.989 4.989 0 003.519-1.463 4.99 4.99 0 001.464-3.52V57.651z"}})])
          )
        }
      }
    